import { Formik, FormikConfig, FormikHelpers, FormikProps, FormikValues } from 'formik';
import React from 'react';
import useClassNames, { IClassNames } from '../../hooks/classNames.hooks';

export interface FormHelpers extends FormikHelpers<any> {
  enableValidation: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface FormProps
  extends Omit<FormikConfig<any>, 'validateOnChange' | 'validateOnBlur' | 'onSubmit'>,
    IClassNames {
  onSubmit: (values: any, helpers: FormHelpers) => void | Promise<any>;
  preventAutoValidation?: boolean;
}

const Form = React.forwardRef<FormikProps<FormikValues>, FormProps>(
  ({ children, onSubmit, preventAutoValidation = false, classNames, ...props }, ref) => {
    const [isValidationEnabled, enableValidation] = React.useState(false);
    const { className } = useClassNames(classNames);

    const handleFormSubmit = (values: FormikValues, helpers: FormikHelpers<any>) =>
      onSubmit(values, {
        ...helpers,
        enableValidation,
      });
    return (
      <Formik
        onSubmit={handleFormSubmit}
        validateOnBlur={isValidationEnabled}
        validateOnChange={isValidationEnabled}
        innerRef={ref}
        {...props}
      >
        {(formikBag: FormikProps<any>) => (
          <form
            noValidate
            className={className}
            onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
              enableValidation(!preventAutoValidation);
              event.preventDefault();
              formikBag.handleSubmit(event);
            }}
          >
            {typeof children === 'function'
              ? (children as (bag: FormikProps<any>) => React.ReactNode)(
                  formikBag as FormikProps<any>,
                )
              : children}
          </form>
        )}
      </Formik>
    );
  },
);

export default Form;
